import { render } from "./createRoughRate.vue?vue&type=template&id=9986e1da&scoped=true"
import script from "./createRoughRate.vue?vue&type=script&lang=js"
export * from "./createRoughRate.vue?vue&type=script&lang=js"

import "./createRoughRate.vue?vue&type=style&index=0&id=9986e1da&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9986e1da"]])

export default __exports__